//
//    WARNING
//    This file was auto-generated by swagger-typescript-codegen.
//    Please do not make changes here because they may be overwritten.
//

import request from 'superagent';
import {
  CallbackHandler,
  CommonRequestOptions,
  ConfigureAgentHandler,
  ConfigureRequestHandler,
  Logger,
  ProblemDetails,
  QueryParameters,
  RequestHeaders,
  RequestHeadersHandler,
  ResponseWithBody,
} from './types';

export type BaseLookupTable = {
  definitions?: Array<LookupTableDefinition>;
  creationDate?: string;
  lastUpdateDate?: string;
  name?: string;
};

export type BaseLookupTableResponseWrapper = {
  data?: BaseLookupTable;
};

export type BucketedSearchRequest = {
  column?: string;
  maximumColumnName?: string;
  minimumColumnName?: string;
  value?: number;
};

export type ColumnFilter = {
  columnName?: string;
  dataType?: string;
  queryOperator?: string;
  value?: string;
};

export type Int32ResponseWrapper = {
  data?: number;
};

export type LookupTable = {
  lookupValues?: Array<Array<StringStringKeyValuePair>>;
  memberDefinitions?: Array<LookupTableMemberDefinition>;
  name?: string;
};

export type LookupTableDefinition = {
  active?: boolean;
  creationDate?: string;
  lastUpdateDate?: string;
  memberDefinitions?: Array<LookupTableMemberDefinition>;
  idColumns?: Array<string>;
  version?: number;
  rowCount?: number;
};

export type LookupTableArrayView = {
  id?: string;
  name?: string;
  definitions?: Array<LookupTableDefinition>;
};

export type LookupTableArrayViewArrayResponseWrapper = {
  data?: Array<LookupTableArrayView>;
};

export type LookupTableMemberDefinition = {
  dataType: string;
  defaultSearchColumn?: boolean;
  name: string;
};

export type LookupTableSet = {
  name?: string;
  versions?: Array<LookupTableVersion>;
};

export type LookupTableSetResponseWrapper = {
  data?: LookupTableSet;
};

export type LookupTableVersion = {
  active?: boolean;
  creationDate?: string;
  lastUpdateDate?: string;
  version?: number;
};

export type PaginatedLookupMembers = {
  continuationToken?: string;
  lookupValues?: Array<Array<StringStringKeyValuePair>>;
};

export type PaginatedLookupMembersResponseWrapper = {
  data?: PaginatedLookupMembers;
};

export type StringResponseWrapper = {
  data?: string;
};

export type StringStringKeyValuePair = {
  key?: string;
  value?: string;
};

export type StringStringKeyValuePairArrayArrayResponseWrapper = {
  data?: Array<Array<StringStringKeyValuePair>>;
};

export type SubstringSearchRequest = {
  minimumLength?: number;
  searchString?: string;
};

export type UpdateLookupTableRequest = {
  activeVersionNumber?: number;
};

/**
 * Insight2Profit lookup
 * @class LookupService
 * @param {(string)} [domainOrOptions] - The project domain.
 */
export class LookupService {
  private domain: string = '';
  private errorHandlers: CallbackHandler[] = [];
  private requestHeadersHandler?: RequestHeadersHandler;
  private configureAgentHandler?: ConfigureAgentHandler;
  private configureRequestHandler?: ConfigureRequestHandler;

  constructor(domain?: string, private logger?: Logger) {
    if (domain) {
      this.domain = domain;
    }
  }

  getDomain() {
    return this.domain;
  }

  addErrorHandler(handler: CallbackHandler) {
    this.errorHandlers.push(handler);
  }

  setRequestHeadersHandler(handler: RequestHeadersHandler) {
    this.requestHeadersHandler = handler;
  }

  setConfigureAgentHandler(handler: ConfigureAgentHandler) {
    this.configureAgentHandler = handler;
  }

  setConfigureRequestHandler(handler: ConfigureRequestHandler) {
    this.configureRequestHandler = handler;
  }

  private request(
    method: string,
    url: string,
    body: any,
    headers: RequestHeaders,
    queryParameters: QueryParameters,
    form: any,
    reject: CallbackHandler,
    resolve: CallbackHandler,
    opts: CommonRequestOptions
  ) {
    if (this.logger) {
      this.logger.log(`Call ${method} ${url}`);
    }

    const agent = this.configureAgentHandler ? this.configureAgentHandler(request) : request;

    let req = agent(method, url);
    if (this.configureRequestHandler) {
      req = this.configureRequestHandler(req);
    }

    req = req.query(queryParameters);

    if (body) {
      req.send(body);

      if (typeof body === 'object' && !(body.constructor.name === 'Buffer')) {
        headers['Content-Type'] = 'application/json';
      }
    }

    headers['x-insight-ns'] = 'master';

    if (Object.keys(form).length > 0) {
      req.type('form');
      req.send(form);
    }

    if (this.requestHeadersHandler) {
      headers = this.requestHeadersHandler({
        ...headers,
      });
    }

    req.set(headers);

    if (opts.$retries && opts.$retries > 0) {
      req.retry(opts.$retries);
    }

    if ((opts.$timeout && opts.$timeout > 0) || (opts.$deadline && opts.$deadline > 0)) {
      req.timeout({
        deadline: opts.$deadline,
        response: opts.$timeout,
      });
    }

    req.end((error, response) => {
      // an error will also be emitted for a 4xx and 5xx status code
      // the error object will then have error.status and error.response fields
      // see superagent error handling: https://github.com/visionmedia/superagent/blob/master/docs/index.md#error-handling
      if (error) {
        reject(error);
        this.errorHandlers.forEach((handler) => handler(error));
      } else {
        resolve(response);
      }
    });
  }

  /**
   *
   * @method
   * @name LookupService#getTables
   * @description /lookup/clients/{clientId}/tables
   * @param {string} clientId - Insight2Profit lookup
   */
  getTables(
    parameters: {
      clientId: string;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, LookupTableArrayViewArrayResponseWrapper> | ResponseWithBody<404, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/lookup/clients/{clientId}/tables';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name LookupService#postTables
   * @description /lookup/clients/{clientId}/tables
   * @param {string} clientId - Insight2Profit lookup
   * @param {} body - Insight2Profit lookup
   */
  postTables(
    parameters: {
      clientId: string;
      body: LookupTable;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, BaseLookupTableResponseWrapper> | ResponseWithBody<404, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/lookup/clients/{clientId}/tables';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';
      headers['Content-Type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name LookupService#postTablesByIdBucketedsearch
   * @description /lookup/clients/{clientId}/tables/{id}/bucketedsearch
   * @param {string} clientId - Insight2Profit lookup
   * @param {string} id - Insight2Profit lookup
   * @param {} body - Insight2Profit lookup
   */
  postTablesByIdBucketedsearch(
    parameters: {
      clientId: string;
      id: string;
      body: BucketedSearchRequest;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, StringResponseWrapper> | ResponseWithBody<404, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/lookup/clients/{clientId}/tables/{id}/bucketedsearch';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';
      headers['Content-Type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name LookupService#getTablesByIdLabelsByLabel
   * @description /lookup/clients/{clientId}/tables/{id}/labels/{label}
   * @param {string} clientId - Insight2Profit lookup
   * @param {string} id - Insight2Profit lookup
   * @param {string} label - Insight2Profit lookup
   */
  getTablesByIdLabelsByLabel(
    parameters: {
      clientId: string;
      id: string;
      label: string;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, StringResponseWrapper> | ResponseWithBody<404, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/lookup/clients/{clientId}/tables/{id}/labels/{label}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      path = path.replace('{label}', `${parameters['label']}`);

      if (parameters['label'] === undefined) {
        reject(new Error('Missing required  parameter: label'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name LookupService#getTablesByIdLabelsByLabelValuesByValue
   * @description /lookup/clients/{clientId}/tables/{id}/labels/{label}/values/{value}
   * @param {string} clientId - Insight2Profit lookup
   * @param {string} id - Insight2Profit lookup
   * @param {string} label - Insight2Profit lookup
   * @param {string} value - Insight2Profit lookup
   */
  getTablesByIdLabelsByLabelValuesByValue(
    parameters: {
      clientId: string;
      id: string;
      label: string;
      value: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, StringResponseWrapper>
    | ResponseWithBody<400, ProblemDetails>
    | ResponseWithBody<404, ProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/lookup/clients/{clientId}/tables/{id}/labels/{label}/values/{value}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      path = path.replace('{label}', `${parameters['label']}`);

      if (parameters['label'] === undefined) {
        reject(new Error('Missing required  parameter: label'));
        return;
      }

      path = path.replace('{value}', `${parameters['value']}`);

      if (parameters['value'] === undefined) {
        reject(new Error('Missing required  parameter: value'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name LookupService#postTablesByIdSubstringsearch
   * @description /lookup/clients/{clientId}/tables/{id}/substringsearch
   * @param {string} clientId - Insight2Profit lookup
   * @param {string} id - Insight2Profit lookup
   * @param {} body - Insight2Profit lookup
   */
  postTablesByIdSubstringsearch(
    parameters: {
      clientId: string;
      id: string;
      body: SubstringSearchRequest;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, StringResponseWrapper> | ResponseWithBody<404, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/lookup/clients/{clientId}/tables/{id}/substringsearch';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';
      headers['Content-Type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name LookupService#postTablesByTableIdFilteredandsearch
   * @description /lookup/clients/{clientId}/tables/{tableId}/filteredandsearch
   * @param {string} clientId - Insight2Profit lookup
   * @param {string} tableId - Insight2Profit lookup
   * @param {} body - Insight2Profit lookup
   */
  postTablesByTableIdFilteredandsearch(
    parameters: {
      clientId: string;
      tableId: string;
      body: Array<ColumnFilter>;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, StringStringKeyValuePairArrayArrayResponseWrapper> | ResponseWithBody<404, ProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/lookup/clients/{clientId}/tables/{tableId}/filteredandsearch';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';
      headers['Content-Type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{tableId}', `${parameters['tableId']}`);

      if (parameters['tableId'] === undefined) {
        reject(new Error('Missing required  parameter: tableId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name LookupService#getTablesByTableIdFilteredsearchByFilter
   * @description /lookup/clients/{clientId}/tables/{tableId}/filteredsearch/{filter}
   * @param {string} clientId - Insight2Profit lookup
   * @param {string} tableId - Insight2Profit lookup
   * @param {string} filter - Insight2Profit lookup
   */
  getTablesByTableIdFilteredsearchByFilter(
    parameters: {
      clientId: string;
      tableId: string;
      filter: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, StringStringKeyValuePairArrayArrayResponseWrapper> | ResponseWithBody<404, ProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/lookup/clients/{clientId}/tables/{tableId}/filteredsearch/{filter}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{tableId}', `${parameters['tableId']}`);

      if (parameters['tableId'] === undefined) {
        reject(new Error('Missing required  parameter: tableId'));
        return;
      }

      path = path.replace('{filter}', `${parameters['filter']}`);

      if (parameters['filter'] === undefined) {
        reject(new Error('Missing required  parameter: filter'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name LookupService#getTablesByTableName
   * @description /lookup/clients/{clientId}/tables/{tableName}
   * @param {string} clientId - Insight2Profit lookup
   * @param {string} tableName - Insight2Profit lookup
   */
  getTablesByTableName(
    parameters: {
      clientId: string;
      tableName: string;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, BaseLookupTableResponseWrapper> | ResponseWithBody<404, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/lookup/clients/{clientId}/tables/{tableName}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{tableName}', `${parameters['tableName']}`);

      if (parameters['tableName'] === undefined) {
        reject(new Error('Missing required  parameter: tableName'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name LookupService#patchTablesByTableName
   * @description /lookup/clients/{clientId}/tables/{tableName}
   * @param {string} clientId - Insight2Profit lookup
   * @param {string} tableName - Insight2Profit lookup
   * @param {} body - Insight2Profit lookup
   */
  patchTablesByTableName(
    parameters: {
      clientId: string;
      tableName: string;
      body: UpdateLookupTableRequest;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, void> | ResponseWithBody<404, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/lookup/clients/{clientId}/tables/{tableName}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';
      headers['Content-Type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{tableName}', `${parameters['tableName']}`);

      if (parameters['tableName'] === undefined) {
        reject(new Error('Missing required  parameter: tableName'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PATCH', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name LookupService#putTablesByTableName
   * @description /lookup/clients/{clientId}/tables/{tableName}
   * @param {string} clientId - Insight2Profit lookup
   * @param {string} tableName - Insight2Profit lookup
   * @param {} body - Insight2Profit lookup
   */
  putTablesByTableName(
    parameters: {
      clientId: string;
      tableName: string;
      body: { memberDefinitions: Array<LookupTableMemberDefinition>; idColumns?: Array<string> };
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, Int32ResponseWrapper> | ResponseWithBody<404, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/lookup/clients/{clientId}/tables/{tableName}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';
      headers['Content-Type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{tableName}', `${parameters['tableName']}`);

      if (parameters['tableName'] === undefined) {
        reject(new Error('Missing required  parameter: tableName'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PUT', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name LookupService#getTablesByTableNameMembers
   * @description /lookup/clients/{clientId}/tables/{tableName}/members
   * @param {string} clientId - Insight2Profit lookup
   * @param {string} tableName - Insight2Profit lookup
   * @param {string} token - Insight2Profit lookup
   */
  getTablesByTableNameMembers(
    parameters: {
      clientId: string;
      tableName: string;
      token?: string;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, PaginatedLookupMembersResponseWrapper> | ResponseWithBody<404, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/lookup/clients/{clientId}/tables/{tableName}/members';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{tableName}', `${parameters['tableName']}`);

      if (parameters['tableName'] === undefined) {
        reject(new Error('Missing required  parameter: tableName'));
        return;
      }

      if (parameters['token'] !== undefined) {
        queryParameters['token'] = parameters['token'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name LookupService#getTablesByTableNameVersions
   * @description /lookup/clients/{clientId}/tables/{tableName}/versions
   * @param {string} clientId - Insight2Profit lookup
   * @param {string} tableName - Insight2Profit lookup
   */
  getTablesByTableNameVersions(
    parameters: {
      clientId: string;
      tableName: string;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, LookupTableSetResponseWrapper> | ResponseWithBody<404, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/lookup/clients/{clientId}/tables/{tableName}/versions';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{tableName}', `${parameters['tableName']}`);

      if (parameters['tableName'] === undefined) {
        reject(new Error('Missing required  parameter: tableName'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name LookupService#deleteTablesByTableNameVersionsByVersionNumber
   * @description /lookup/clients/{clientId}/tables/{tableName}/versions/{versionNumber}
   * @param {string} clientId - Insight2Profit lookup
   * @param {string} tableName - Insight2Profit lookup
   * @param {integer} versionNumber - Insight2Profit lookup
   * @param {boolean} overrideActiveFlag - Insight2Profit lookup
   */
  deleteTablesByTableNameVersionsByVersionNumber(
    parameters: {
      clientId: string;
      tableName: string;
      versionNumber: number;
      overrideActiveFlag?: boolean;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, void> | ResponseWithBody<404, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/lookup/clients/{clientId}/tables/{tableName}/versions/{versionNumber}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{tableName}', `${parameters['tableName']}`);

      if (parameters['tableName'] === undefined) {
        reject(new Error('Missing required  parameter: tableName'));
        return;
      }

      path = path.replace('{versionNumber}', `${parameters['versionNumber']}`);

      if (parameters['versionNumber'] === undefined) {
        reject(new Error('Missing required  parameter: versionNumber'));
        return;
      }

      if (parameters['overrideActiveFlag'] !== undefined) {
        queryParameters['overrideActiveFlag'] = parameters['overrideActiveFlag'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name LookupService#patchTablesByTableNameVersionsByVersionNumber
   * @description /lookup/clients/{clientId}/tables/{tableName}/versions/{versionNumber}
   * @param {string} clientId - Insight2Profit lookup
   * @param {string} tableName - Insight2Profit lookup
   * @param {integer} versionNumber - Insight2Profit lookup
   * @param {} body - Insight2Profit lookup
   */
  patchTablesByTableNameVersionsByVersionNumber(
    parameters: {
      clientId: string;
      tableName: string;
      versionNumber: number;
      body: Array<Array<StringStringKeyValuePair>>;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, void> | ResponseWithBody<404, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/lookup/clients/{clientId}/tables/{tableName}/versions/{versionNumber}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';
      headers['Content-Type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{tableName}', `${parameters['tableName']}`);

      if (parameters['tableName'] === undefined) {
        reject(new Error('Missing required  parameter: tableName'));
        return;
      }

      path = path.replace('{versionNumber}', `${parameters['versionNumber']}`);

      if (parameters['versionNumber'] === undefined) {
        reject(new Error('Missing required  parameter: versionNumber'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PATCH', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name LookupService#deleteTablesByTableNameVersionsByVersionNumberMembers
   * @description /lookup/clients/{clientId}/tables/{tableName}/versions/{versionNumber}/members
   * @param {string} clientId - Insight2Profit lookup
   * @param {string} tableName - Insight2Profit lookup
   * @param {integer} versionNumber - Insight2Profit lookup
   * @param {} body - Insight2Profit lookup
   */
  deleteTablesByTableNameVersionsByVersionNumberMembers(
    parameters: {
      clientId: string;
      tableName: string;
      versionNumber: number;
      body: Array<Array<StringStringKeyValuePair>>;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, Int32ResponseWrapper> | ResponseWithBody<404, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/lookup/clients/{clientId}/tables/{tableName}/versions/{versionNumber}/members';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';
      headers['Content-Type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{tableName}', `${parameters['tableName']}`);

      if (parameters['tableName'] === undefined) {
        reject(new Error('Missing required  parameter: tableName'));
        return;
      }

      path = path.replace('{versionNumber}', `${parameters['versionNumber']}`);

      if (parameters['versionNumber'] === undefined) {
        reject(new Error('Missing required  parameter: versionNumber'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name LookupService#getTablesByTableNameVersionsByVersionNumberMembers
   * @description /lookup/clients/{clientId}/tables/{tableName}/versions/{versionNumber}/members
   * @param {string} clientId - Insight2Profit lookup
   * @param {string} tableName - Insight2Profit lookup
   * @param {integer} versionNumber - Insight2Profit lookup
   * @param {string} token - Insight2Profit lookup
   */
  getTablesByTableNameVersionsByVersionNumberMembers(
    parameters: {
      clientId: string;
      tableName: string;
      versionNumber: number;
      token?: string;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, PaginatedLookupMembersResponseWrapper> | ResponseWithBody<404, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/lookup/clients/{clientId}/tables/{tableName}/versions/{versionNumber}/members';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{tableName}', `${parameters['tableName']}`);

      if (parameters['tableName'] === undefined) {
        reject(new Error('Missing required  parameter: tableName'));
        return;
      }

      path = path.replace('{versionNumber}', `${parameters['versionNumber']}`);

      if (parameters['versionNumber'] === undefined) {
        reject(new Error('Missing required  parameter: versionNumber'));
        return;
      }

      if (parameters['token'] !== undefined) {
        queryParameters['token'] = parameters['token'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }
}

export default LookupService;
